// Tables · DocumentPill helpers
//
// Split out of `DocumentPill.tsx` so that module exports components only.

import type { ReviewStatus } from "@shared/types";

/**
 * Single review-tone contract shared across every document context.
 * Worst wins (legacy ordering): `pending` > `not_approved` > `approved` > `none`.
 */
export type ReviewTone = "pending" | "approved" | "not_approved" | "none";

/** Presence/lifecycle state of the pill's document(s). */
export type DocumentPillState = "present" | "missing" | "unmatched" | "generating";

/**
 * Worst-wins reduction over a set of `review_status` values into the unified
 * `ReviewTone`. Replaces the per-file tone loops previously duplicated in
 * `TransactionDocsBucket` and `DocStatusPill`.
 *
 * Legacy ordering, preserved verbatim: `pending` (amber) beats `not_approved`
 * (red) beats `approved` (green) beats `none` (neutral). `not_applicable`
 * contributes nothing. Switching to red-first ("worst" = rejected) would be a
 * product decision — deliberately not taken in this refactor.
 */
export function worstReviewTone(statuses: ReadonlyArray<ReviewStatus>): ReviewTone {
  let seenRejected = false;
  let seenApproved = false;
  for (const s of statuses) {
    if (s === "pending") return "pending";
    if (s === "not_approved") seenRejected = true;
    else if (s === "approved") seenApproved = true;
  }
  if (seenRejected) return "not_approved";
  if (seenApproved) return "approved";
  return "none";
}

